import request from '@/utils/request'

let Identity_verificationApi = {

  /*身份认证列表*/
  list(data) {
    return request._post('/shop/plus.identity_verification.Index/index', data);
},
updatestatus(data){
    return request._post('/shop/plus.identity_verification.Index/updatestatus', data);
},
/*添加身份认证*/
add(data) {
    return request._post('/shop/plus.identity_verification.Index/add', data);
},
/*修改身份认证*/
edit(data) {
    return request._post('/shop/plus.identity_verification.Index/edit', data);
},
/*删除身份认证*/
del(data) {
    return request._post('/shop/plus.identity_verification.Index/del', data);
},
/*身份认证详情*/
detail(data) {
  return request._post('/shop/plus.identity_verification.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.identity_verification.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.identity_verification.Setting/getSetting', data, errorback);
    },
}
export default Identity_verificationApi;



// WEBPACK FOOTER //
// ./src/api/identity_verification.js